export function trMoney(value) {
  const num = Number(value || 0);

  try {
    return `${num.toLocaleString('tr-TR')} ₺`;
  } catch (e) {
    return `${num} ₺`;
  }
}
